<div class="tap-top" (click)="tapToTop()">
  <div>
    <i class="ri-arrow-up-double-line"></i>
  </div>
</div>
